"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sources = exports.sourceKeys = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _sources;

var sourceKeys = (0, _keyMirror.default)({
  GENERAL: null,
  UPGRADE_BUTTON: null,
  // Will be deprecated
  USAGE_LIMIT: null,
  LIMIT_PACK: null,
  FEATURE_LIMIT: null,
  // Will be deprecated
  CHECKOUT: null,
  CONTACT_SALES: null,
  CONTACT_SALES_BUTTON: null,
  TRIAL: null,
  // Deprecated
  TRIAL_BUTTON: null,
  EXPIRED_TRIAL_MODAL: null,
  TRIAL_MODAL: null,
  LOCKED_FEATURE: null,
  LOCKED_APP: null,
  UPGRADE_BANNER: null,
  PRODUCT_ACTIVATION: null,
  STANDALONE: null
});
exports.sourceKeys = sourceKeys;
var sources = (_sources = {}, (0, _defineProperty2.default)(_sources, sourceKeys.GENERAL, 'general'), (0, _defineProperty2.default)(_sources, sourceKeys.UPGRADE_BUTTON, 'upgrade-button'), (0, _defineProperty2.default)(_sources, sourceKeys.USAGE_LIMIT, 'usage-limit'), (0, _defineProperty2.default)(_sources, sourceKeys.LIMIT_PACK, 'limit-pack'), (0, _defineProperty2.default)(_sources, sourceKeys.FEATURE_LIMIT, 'feature-limit'), (0, _defineProperty2.default)(_sources, sourceKeys.CHECKOUT, 'checkout'), (0, _defineProperty2.default)(_sources, sourceKeys.CONTACT_SALES, 'contact-sales'), (0, _defineProperty2.default)(_sources, sourceKeys.CONTACT_SALES_BUTTON, 'contact-sales-button'), (0, _defineProperty2.default)(_sources, sourceKeys.TRIAL, 'trial'), (0, _defineProperty2.default)(_sources, sourceKeys.TRIAL_BUTTON, 'trial-button'), (0, _defineProperty2.default)(_sources, sourceKeys.EXPIRED_TRIAL_MODAL, 'expired-trial-modal'), (0, _defineProperty2.default)(_sources, sourceKeys.TRIAL_MODAL, 'trial-modal'), (0, _defineProperty2.default)(_sources, sourceKeys.LOCKED_FEATURE, 'locked-feature'), (0, _defineProperty2.default)(_sources, sourceKeys.LOCKED_APP, 'locked-app'), (0, _defineProperty2.default)(_sources, sourceKeys.UPGRADE_BANNER, 'upgrade-banner'), (0, _defineProperty2.default)(_sources, sourceKeys.PRODUCT_ACTIVATION, 'product-activation'), (0, _defineProperty2.default)(_sources, sourceKeys.STANDALONE, 'standalone'), _sources);
exports.sources = sources;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/common/data/upgradeData/properties/sources.js
// module id = 132
// module chunks = 5 6